import api from './axios';
import type { StatisticsItem } from '../types';

/**
 * avgPlace и matchesCount считаются по ПАРЕ «родитель + запись»: для предмета в топе героя —
 * место игроков, игравших ЭТИМ героем С ЭТИМ предметом.
 */
export type StatisticsEntry = {
  name: string;
  matchesCount: number;
  /** Доля матчей родителя, 0..1. */
  share: number;
  avgPlace: number | null;
};

type EntityStatisticsBase = {
  name: string;
  matchesCount: number;
  pickRate: number;
  avgPlace: number | null;
  avgRounds: number | null;
};

export type HeroStatisticsDetail = EntityStatisticsBase & {
  topItems: StatisticsEntry[];
  topAbilities: StatisticsEntry[];
};

export type AbilityStatisticsDetail = EntityStatisticsBase & {
  topHeroes: StatisticsEntry[];
};

export type ItemStatisticsDetail = EntityStatisticsBase & {
  topHeroes: StatisticsEntry[];
};

export type ItemsStatisticsResponse = {
  items: StatisticsItem[];
};

export type HeroMatchEntry = {
  matchId: string;
  matchTypeCode: string;
  startDateTime: string | null;
  endDateTime: string | null;
  round: number | null;
  playerUid: string;
  playerName: string | null;
  place: number | null;
  ratingChange: number | null;
};

export type HeroMatchesResponse = {
  matches: HeroMatchEntry[];
};

export const HERO_RECENT_MATCHES_LIMIT = 10;

const statisticsPath = (section: 'heroes' | 'abilities' | 'items', name?: string): string =>
  name === undefined ? `/api/statistics/${section}` : `/api/statistics/${section}/${encodeURIComponent(name)}`;

export const getHeroStatistics = (heroName: string): Promise<HeroStatisticsDetail> =>
  api.get<HeroStatisticsDetail>(statisticsPath('heroes', heroName)).then(res => res.data);

export const getHeroRecentMatches = (
  heroName: string,
  limit: number = HERO_RECENT_MATCHES_LIMIT
): Promise<HeroMatchesResponse> =>
  api
    .get<HeroMatchesResponse>(`${statisticsPath('heroes', heroName)}/matches`, { params: { limit } })
    .then(res => res.data);

export const getAbilityStatistics = (abilityName: string): Promise<AbilityStatisticsDetail> =>
  api.get<AbilityStatisticsDetail>(statisticsPath('abilities', abilityName)).then(res => res.data);

export const getItemStatistics = (itemName: string): Promise<ItemStatisticsDetail> =>
  api.get<ItemStatisticsDetail>(statisticsPath('items', itemName)).then(res => res.data);

export const getItemsStatistics = (): Promise<ItemsStatisticsResponse> =>
  api.get<ItemsStatisticsResponse>(statisticsPath('items')).then(res => res.data);
